import React, { useEffect } from "react";
import styles from './main.module.css';
import { CLEAR_PATH_PARAMS } from "../../services/actions/path_params_actions";
import Loader from "../../components/loader/loader";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { getDataFromRoutes, setMetaTags } from "../../utils/util_functions";
import { getLoading } from "../../services/selectors";
import { ROUTES_CONST } from "../../utils/constants";


function Main() {

  const location = useLocation();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: CLEAR_PATH_PARAMS });
    // eslint-disable-next-line
  }, [location]);

  const {
    metaTitle, metaDescription, metaKeywords, metaRobots
  } = getDataFromRoutes(location.pathname, ROUTES_CONST);
  useEffect(() => {
    setMetaTags(metaTitle, metaDescription, metaKeywords, metaRobots);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {window.scrollTo({top: 0, left: 0})}, []);


  const isLoading = useSelector(getLoading);


  return (
    <main className='main'>
      {isLoading ? <Loader /> :
        <>
          <p style={{
            fontWeight: "300",
            fontSize: "10px",
            color: "red"
          }}>Регистрация 300</p>
          <p style={{
            fontWeight: "400",
            fontSize: "20px",
            color: "red"
          }}>Регистрация 400</p>
          <p style={{
            fontWeight: "500",
            fontSize: "30px",
            color: "red"
          }}>Регистрация 500</p>
          <p style={{
            fontWeight: "700",
            fontSize: "40px",
            color: "red"
          }}>Регистрация 700</p>
        </>
      }
    </main>
  );
}

export default Main;
